import React from 'react';
import { DigitalChain } from '../DigitalChain';
import { useBeats } from '../../hooks/useBeats';
import { journey } from '../../data/teaser';
const BEATS = [500, 900, 1300, 1700, 2400, 3200, 4200];
export function ScreenJourney() {
  const beat = useBeats(BEATS);
  return <section className="flex h-full w-full flex-col justify-center" data-id="element-122" data-mp="3svnlfgahb2uj">
      <h1 className="text-[25px] font-extrabold leading-[1.16] text-white animate-fade-in-up" data-id="element-123" data-mp="3sucjzn4ia76l">
        A digital treatment is only as precise as its last manual step.
      </h1>

      <div className="mt-8" data-id="element-124" data-mp="5hs0yq57f3vp">
        <DigitalChain steps={journey} revealed={Math.min(beat, journey.length)} finalTag={beat >= 5 ? 'Manual' : undefined} data-id="element-125" data-mp="5knwk7tkxggz" />
      </div>

      <p className={`mt-9 font-headline text-[19px] font-bold leading-snug text-white transition-[opacity,transform] duration-300 ease-out ${beat >= 6 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-126" data-mp="fhai6ytqcbk2">
        Almost everything is digital.
      </p>

      <p className={`mt-2 font-headline text-[24px] font-extrabold leading-snug text-solventum-primary transition-[opacity,transform] duration-300 ease-out ${beat >= 7 ? 'translate-y-0 opacity-100' : 'translate-y-2.5 opacity-0'}`} data-id="element-127" data-mp="2mw7wl37652u6">
        Until the attachment.
      </p>
    </section>;
}